import { useAssignedStoreUpdateQueries } from "./useAssignedStoreUpdateQueries"

export const useAssignedStoreUpdate = () =>
{
    const {updateRecipeStoreMuate} = useAssignedStoreUpdateQueries();
    return {updateRecipeStoreMuate};
}